import { createQueryDataContext } from '../contexts/QueryDataContext';
import { createQueryDataProvider } from '../providers/query-data-provider';
import { createQueryDataHooks } from '../utils/query-data-hooks';
import { configQueryCache } from './query-cache';
export const configQueryData = ({
  dataFetchingClientOptions
} = {}) => {
  const QueryDataContext = createQueryDataContext();
  const queryCache = configQueryCache();
  const QueryDataProvider = createQueryDataProvider(QueryDataContext, queryCache, dataFetchingClientOptions);
  const hooks = createQueryDataHooks(QueryDataContext);
  const {
    cacheMutation,
    cacheQuery,
    registerMutationToCache,
    registerQueryToCache,
    registerApolloQueryToCache
  } = queryCache;
  return Object.assign({
    QueryDataProvider,
    cacheMutation,
    cacheQuery,
    registerMutationToCache,
    registerQueryToCache,
    registerApolloQueryToCache
  }, hooks);
};